import React from "react";
import { motion } from "framer-motion";
import "./Commemorative.css";
import tribute from "../assets/willie.jpg";

export default function TributeSection() {
  return (
    <section className="tribute">

      <motion.p
        className="tribute-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        HONOR A UN LEGADO
      </motion.p>

      <motion.h2
        className="tribute-title"
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
      >
        Willie Colón.
      </motion.h2>

      <motion.div
        className="tribute-frame"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        <img src={tribute} alt="Tribute" />
      </motion.div>

      <motion.p
        className="tribute-text"
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7 }}
      >
       Este arte en homenaje representa al arquitecto de un sonido que marcó generaciones.
El trono dorado simboliza su reinado, el blanco pureza y elegancia, y detrás de él, cada álbum como testigo de un legado inmortal.

Pero para mí va más allá de la historia…
Muchas veces su música fue el fondo de mis procesos creativos. Mientras diseñaba, mientras soñaba, mientras construía mi camino, sonaba Willie.

Gracias por tanto, Maestro.
      </motion.p>

      <div className="tribute-divider">
        <span></span>
        <div className="star">★</div>
        <span></span>
      </div>

    </section>
  );
}